import storageKeys from '@/constants/storageKeys'

const euRegion = 'eu'
const globalRegion = 'gb'
const maxInputLength = 200

export default {
  euRegion,
  globalRegion,
  storageKeys,
  slideTypes: {
    multipleChoice: {
      name: 'Multilple Choice',
      icon: 'fas fa-chart-bar',
      type: 'multipleChoice',
    },
  },
  colorsHex: ['#4EAAF1', '#FFAF09', '#28C270', '#FF5DA1', '#7669BF', '#124345'],
  emojis: [
    '👍',
    '😜',
    '😀',
    '😍',
    '😘',
    '😆',
    '😷',
    '😠',
    '😅',
    '😂',
    '😱',
    '🤩',
    '🤗',
    '😭',
    '😈',
    '👿',
    '👹',
    '👺',
    '💀',
    '☠️',
    '🙊',
    '🙉',
    '🙈',
    '😾',
    '😺',
    '😸',
    '😹',
    '😻',
    '🙀',
    '😽',
    '😼',
    '👻',
    '👩‍🎓',
    '👨‍🎓',
    '👩‍🍳',
    '👨‍🔧',
    '👩‍🔧',
    '👨‍🎤',
    '👩‍🚒',
    '👨‍🚒',
    '👩‍🚀',
    '👨‍🚀',
    '👩‍✈️',
    '👨‍🔬',
    '👳',
    '👳‍♂️',
    '🤰',
    '🤱',
    '🎅',
    '👼',
    '🧛',
    '🧝‍♂️',
    '🧞',
    '🧙‍♂️',
    '🧜‍♂️',
    '🧜‍♀️',
    '🧙‍♀️',
    '🧟‍♀️',
    '🙅‍♀️',
    '🙆‍♂️',
    '🙇‍♂️',
    '💆‍♂️',
    '💇',
    '🚵',
    '🤼‍♂️',
    '🤹‍♂️',
    '👨‍👩‍👧‍👧',
    '💑',
    '👨‍❤️‍💋‍👨',
    '👩‍❤️‍💋‍👨',
    '👨‍👩‍👧',
    '👪',
    '👨‍👩‍👦',
    '👨‍👨‍👦‍👦',
    '👩‍👧',
    '👩‍👧‍👧',
    '🛍️',
    '🧤',
    '🧣',
    '👜',
    '👛',
    '👚',
    '🍜',
  ],
  fonts: {
    jakarta: {
      url: 'https://fonts.googleapis.com/css?family=Plus+Jakarta+Sans:400,600&display=swap&subset=latin-ext,vietnamese',
      value: "'Plus Jakarta Sans', sans-serif",
      name: 'jakarta',
      label: 'Plus Jakarta Sans (default)',
    },
    roboto: {
      url: 'https://fonts.googleapis.com/css?family=Roboto:400,600&display=swap&subset=latin-ext,vietnamese',
      value: "'Roboto', sans-serif",
      name: 'roboto',
      label: 'Roboto',
    },
    opensan: {
      url: 'https://fonts.googleapis.com/css?family=Open+Sans:400,600&display=swap&subset=latin-ext,vietnamese',
      value: "'Open Sans', sans-serif",
      name: 'opensan',
      label: 'Open Sans',
    },
    oswald: {
      url: 'https://fonts.googleapis.com/css?family=Oswald:400,600&display=swap&subset=latin-ext,vietnamese',
      value: "'Oswald', sans-serif",
      name: 'oswald',
      label: 'Oswald',
    },
    montserrat: {
      url: 'https://fonts.googleapis.com/css?family=Montserrat:400,600&display=swap&subset=latin-ext,vietnamese',
      value: "'Montserrat', sans-serif",
      name: 'montserrat',
      label: 'Montserrat',
    },
    sourceCodePro: {
      url: 'https://fonts.googleapis.com/css?family=Source+Code+Pro:400,600&display=swap&subset=latin-ext,vietnamese',
      value: "'Source Code Pro', 'Courier New', Courier, monospace",
      name: 'sourceCodePro',
      label: 'Source Code Pro',
    },
    merriweather: {
      url: 'https://fonts.googleapis.com/css?family=Merriweather:400,600&display=swap&subset=latin-ext,vietnamese',
      value: "'Merriweather', serif",
      name: 'merriweather',
      label: 'Merriweather',
    },
    ebGaramond: {
      url: 'https://fonts.googleapis.com/css?family=EB+Garamond:400,600&display=swap&subset=latin-ext,vietnamese',
      value: "'EB Garamond', serif",
      name: 'ebGaramond',
      label: 'EB Garamond',
    },
    robotoSlab: {
      url: 'https://fonts.googleapis.com/css?family=Roboto+Slab:400,600&display=swap&subset=latin-ext,vietnamese',
      value: "'Roboto Slab', serif",
      name: 'robotoSlab',
      label: 'Roboto Slab',
    },
    cairo: {
      url: 'https://fonts.googleapis.com/css?family=Cairo:400,600&display=swap&subset=arabic',
      value: "'Cairo', sans-serif",
      name: 'cairo',
      label: 'Cairo',
    },
    nunito: {
      url: 'https://fonts.googleapis.com/css?family=Nunito:400,600&display=swap&subset=latin-ext,vietnamese',
      value: "'Nunito', sans-serif",
      name: 'nunito',
      label: 'Nunito',
    },
    kanit: {
      url: 'https://fonts.googleapis.com/css?family=Kanit:400,600&display=swap&subset=thai',
      value: "'Kanit', sans-serif",
      name: 'kanit',
      label: 'Kanit',
    },
  },
  // Change to colors after remove feature flag canUseNewColors
  colors2025: [
    '#FF4181',
    '#1FE8B4',
    '#FF9068',
    '#3E3E5A',
    '#D92B6B',
    '#16C49A',
    '#5715A0',
    '#E65B29',
    '#27487A',
    '#0F6E65',
  ],
  // Change to lighterColors after remove feature flag canUseNewColors
  lighterColors2025: [
    'rgba(255, 65, 129, 0.8)',
    'rgba(31, 232, 180, 0.8)',
    'rgba(255, 144, 104, 0.8)',
    'rgba(62, 62, 90, 0.8)',
    'rgba(217, 43, 107, 0.8)',
    'rgba(22, 196, 154, 0.8)',
    'rgba(87, 21, 160, 0.8)',
    'rgba(230, 91, 41, 0.8)',
    'rgba(39, 72, 122, 0.8)',
    'rgba(15, 110, 101, 0.8)',
  ],
  // Change to legacyColors after remove feature flag canUseNewColors
  colors: [
    // https://trello.com/c/383hc2zf/430-%C4%91%E1%BB%95i-list-m%C3%A0u-d%C3%B9ng-cho-c%C3%A1c-chart
    'rgba(78, 170, 241, 1)', // blue
    'rgba(255, 175, 9, 1)', // yel
    'rgba(40, 194, 112, 1)', // green
    'rgba(253, 93, 161, 1)', // pink
    'rgba(118, 105, 191, 1)', // purple
    'rgba(18, 67, 69, 1)', // dark teal
    'rgba(156, 162, 174, 1)', // grey
    'rgba(79, 151, 241, 1)', // blue 2
    'rgba(255, 199, 0, 1)', // yel 2
    'rgba(40, 194, 129, 1)', // green 2
    'rgba(253, 93, 142, 1)', // pink 2
    'rgba(127, 105, 191, 1)', // purple 2
    'rgba(37, 43, 53, 1)', // near black
    'rgba(156, 165, 174, 1)', // grey 2
    'rgba(77, 183, 240, 1)', // blue 3
    'rgba(255, 156, 16, 1)', // orange
    'rgba(40, 194, 99, 1)', // green 3
    'rgba(253, 92, 173, 1)', // pink 3
    'rgba(110, 105, 191, 1)', // purple 3
    'rgba(59, 30, 54, 1)', // dark plum
    'rgba(162, 155, 175, 1)', // grey purple
    'rgba(116, 76, 242, 1)', // purple 4
    'rgba(154, 240, 37, 1)', // neon green
    'rgba(43, 158, 195, 1)', // sky
    'rgba(253, 152, 89, 1)', // light orange
    'rgba(182, 105, 191, 1)', // weird purple
    'rgba(55, 52, 33, 1)', // some brown-green
    'rgba(155, 170, 174, 1)', // grey blue
    'rgba(74, 225, 239, 1)', // fresh blue
    'rgba(255, 100, 28, 1)', // fresh orange
  ],
  // Change to legacyLighterColors after remove feature flag canUseNewColors
  lighterColors: [
    '#c7e2f4',
    '#fce4b6',
    '#bee9cd',
    '#fbcadc',
    '#d3cfe5', // purple 1st
    '#b6c3c1',
    '#dedfe0', // 1st gray
    '#c7dcf4',
    '#fcebb6', // 2nd yellow
    '#bee9d3',
    '#fbcbd7', // 2nd pink
    '#d5cfe5', // 2nd purple
    '#bbbcbc',
    '#dee0e0', // 2nd gray
    '#c7e6f4', // 3rd blue
    '#fcddb7',
    '#bee9ca',
    '#fbcae0', // 3rd pink
    '#d1cfe5', // 3rd purple
    '#c1b8bc',
    '#e0dde0',
    '#d2c7f4',
    '#ddf7bb', // yellow green
    '#bedee7',
    '#fbdcc8',
    '#e6cee5', // last purple
    '#c0beb6',
    '#dee1e0',
    '#c7f2f3',
    '#fccdb7',
  ],
  tabQnaQuestion: {
    TOP: 1,
    NEW: 2,
    ANSWERED: 3,
    MY_QUESTIONS: 4,
  },
  stoppedSendingToGoogleTagEvents: [
    'audience_signup',
    'audience_login',
  ],
  TRACKING_SAMPLE_RATE: 0.05,
  maxInputLength,
  systemField: ['name', 'email', 'team', 'avatar'],
}
